module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAWCAMAAAAGlBe5AAAAUVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////8IN+deAAAAGnRSTlMAECAwQE9QX2BvcH+Aj5CfoK+wv8DP0N/g8C0K7hcAAACiSURBVBgZbcGLQoMgAIbRj0tEjsxpLvnf/0GLpqjMc2j4uzTfDFgHpMgu6d/8cc8GWBTZBG2yCwYk3Vgt2vyoA7Kk2VEY7RJ/BhXTO+BV9RQ262n6+lSVKLzPepUosq4EilFXHIXThYWnqFc9Kz+q5VgNkxoDm6hGtlS9zgIHfvzWLnHiZlUdB/ZtUpUDlRt11BsOTHxo9UiWlvEppc5bzn4BjdIiCijtU0oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/f2Active.png
// module id = QPqj
// module chunks = 21